export const validatePhone = (phone: string): boolean => {
  // Remove caracteres não numéricos
  const cleanPhone = phone.replace(/\D/g, '');

  // Verifica se tem o tamanho correto (10 ou 11 dígitos)
  if (![10, 11].includes(cleanPhone.length)) {
    return false;
  }

  // Não pode começar com 0
  if (cleanPhone.startsWith('0')) {
    return false;
  }

  // Extrai o DDD
  const ddd = Number(cleanPhone.substring(0, 2));

  // Valida DDD (códigos de área válidos no Brasil)
  if (ddd < 11 || ddd > 99) {
    return false;
  }

  // Se for celular (11 dígitos)
  if (cleanPhone.length === 11) {
    // Primeiro dígito após DDD deve ser 9
    return cleanPhone[2] === '9';
  }

  return true;
};
